module.exports = __webpack_public_path__ + "static/media/report_1.5bcfe730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/report_1.jpg
// module id = 410
// module chunks = 0